/*
  Find Your Fix — guided product finder.

  All matching is driven by product metafields rendered into the section's
  JSON payload by sections/find-your-fix.liquid:
    custom.use_on     -> Q1 surface
    custom.attributes -> Q2 conditions
    custom.set_time   -> Q3 speed
    product type      -> optional Q4 format + epoxy preference

  Answer options are derived from the values present on the products, so the
  question vocabulary can never drift from the catalogue.
*/
(function(){
  "use strict";

  function boot(root){
    if(root.getAttribute("data-fyf-ready") === "1") return;
    var payloadEl = root.querySelector("[data-fyf-payload]");
    var stage = root.querySelector("[data-fyf-stage]");
    var stepperEl = root.querySelector("[data-fyf-stepper]");
    if(!payloadEl || !stage || !stepperEl) return;

    var DATA;
    try { DATA = JSON.parse(payloadEl.textContent); } catch(e){ return; }
    root.setAttribute("data-fyf-ready", "1");

    var stepEls = stepperEl.children;
    var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var Q = DATA.questions || {};

    function arr(v){ return Object.prototype.toString.call(v) === "[object Array]" ? v : []; }

    function minutesOf(txt){
      if(!txt) return null;
      var s = String(txt).toLowerCase();
      var sec = s.match(/([0-9]+)[ ]*sec/);
      if(sec) return Math.max(1, Math.round(parseInt(sec[1], 10) / 60));
      if(/instant|immediate|less than (a|1)[ ]*min/.test(s)) return 1;
      var nums = s.match(/[0-9]+([.][0-9]+)?/g);
      if(!nums) return null;
      var n = Math.max.apply(null, nums.map(Number));
      if(/hour|hr/.test(s)) return n * 60;
      if(/day/.test(s)) return n * 1440;
      return n;
    }

    var P = DATA.products.map(function(p){
      p.use = arr(p.use);
      p.att = arr(p.att);
      p.mins = minutesOf(p.set);
      return p;
    }).filter(function(p){ return p.use.length || p.att.length; });

    var EPOXY = {};
    String(DATA.epoxyTypes || "").split(",").forEach(function(t){
      t = t.trim();
      if(t) EPOXY[t.toLowerCase()] = 1;
    });
    function isEpoxy(p){ return !!DATA.prioritizeEpoxy && !!EPOXY[String(p.type || "").toLowerCase()]; }
    var EPOXY_BOOST = 2;

    function tally(key, cap){
      var counts = {}, order = [];
      P.forEach(function(p){
        p[key].forEach(function(v){
          if(!counts[v]){ counts[v] = 0; order.push(v); }
          counts[v]++;
        });
      });
      return order.sort(function(a, b){
        return counts[b] - counts[a] || a.localeCompare(b);
      }).slice(0, cap).map(function(v){ return {v:v, n:counts[v]}; });
    }
    var SURFACES = tally("use", DATA.maxSurfaces || 12);
    var CONDITIONS = tally("att", DATA.maxConditions || 10);

    var SPEEDS = [
      ["Right now", "Sets in about a minute", 1],
      ["A few minutes", "Sets within 15 minutes", 15],
      ["Within the hour", "Sets within an hour", 60],
      ["Time is not a factor", "Strongest option wins", 1000000000]
    ];

    var RESULTS_STEP = DATA.showFormat ? 4 : 3;
    var state = newState();
    function newState(){
      return {step:0, surface:null, conditions:[], speed:null, format:null, answeredFormat:false};
    }

    function pools(){
      var relaxed = null;
      var surfacePool = P.filter(function(p){ return p.use.indexOf(state.surface) > -1; });
      if(!surfacePool.length){ surfacePool = P.slice(); relaxed = "surface"; }
      var strict = surfacePool.filter(function(p){
        if(!state.conditions.length) return true;
        return state.conditions.every(function(c){ return p.att.indexOf(c) > -1; });
      });
      if(!strict.length && !relaxed) relaxed = "conditions";
      return {surfacePool:surfacePool, strict:strict, relaxed:relaxed};
    }

    function formatOptions(){
      var cp = pools();
      var base = cp.strict.length ? cp.strict : cp.surfacePool;
      var counts = {}, order = [];
      base.forEach(function(p){
        var t = p.type || "Other";
        if(!counts[t]){ counts[t] = 0; order.push(t); }
        counts[t]++;
      });
      return order.sort(function(a, b){
        var ea = EPOXY[a.toLowerCase()] ? 1 : 0, eb = EPOXY[b.toLowerCase()] ? 1 : 0;
        if(ea !== eb) return eb - ea;
        return counts[b] - counts[a];
      }).map(function(t){
        return {type:t, n:counts[t], epoxy:!!EPOXY[t.toLowerCase()]};
      });
    }

    function score(p){
      var s = 0, hits = [];
      state.conditions.forEach(function(c){
        if(p.att.indexOf(c) > -1){ s += 4; hits.push(c); }
      });
      var cap = state.speed ? state.speed[2] : 1000000000;
      if(p.mins !== null && p.mins <= cap) s += 3;
      else if(p.mins === null) s += 0.5;
      s += Math.min(p.use.length, 6) * 0.15;
      if(isEpoxy(p)) s += EPOXY_BOOST;
      if(!p.avail) s -= 1.5;
      return {score:s, hits:hits};
    }

    function el(tag, cls, text){
      var n = document.createElement(tag);
      if(cls) n.className = cls;
      if(text !== null && text !== undefined) n.textContent = text;
      return n;
    }
    function tile(label, sub, pressed){
      var b = el("button", "fyf-tile");
      b.type = "button";
      b.setAttribute("aria-pressed", pressed ? "true" : "false");
      b.appendChild(el("span", "t", label));
      if(sub) b.appendChild(el("span", "s", sub));
      return b;
    }
    function plural(n, word){ return n + " " + word + (n === 1 ? "" : "s"); }
    function lower(s){ return String(s).toLowerCase(); }

    function legendFor(title, help, optional){
      var lg = document.createElement("legend");
      var h = el("div", "fyf-q", title);
      if(optional) h.appendChild(el("span", "fyf-opt", "Optional"));
      lg.appendChild(h);
      if(help) lg.appendChild(el("p", "fyf-help", help));
      return lg;
    }

    function paintStepper(){
      for(var i = 0; i < stepEls.length; i++){
        var st = state.step > i ? "done" : (state.step === i ? "active" : "");
        if(st) stepEls[i].setAttribute("data-state", st);
        else stepEls[i].removeAttribute("data-state");
      }
    }

    function renderQuestion(){
      stage.innerHTML = "";
      paintStepper();

      var fs = el("fieldset");
      var grid = el("div", "fyf-grid");
      var actions = el("div", "fyf-actions");

      if(state.step === 0){
        fs.appendChild(legendFor(Q.surface, Q.surfaceHelp, false));
        SURFACES.forEach(function(o){
          var b = tile(o.v, plural(o.n, "product"), state.surface === o.v);
          b.addEventListener("click", function(){
            state.surface = o.v; state.step = 1; renderQuestion();
          });
          grid.appendChild(b);
        });
        fs.appendChild(grid);

      } else if(state.step === 1){
        fs.appendChild(legendFor(Q.conditions, Q.conditionsHelp, false));
        var cnt = el("span", "fyf-count", state.conditions.length ? state.conditions.length + " selected" : "None selected");
        CONDITIONS.forEach(function(o){
          var b = tile(o.v, plural(o.n, "product"), state.conditions.indexOf(o.v) > -1);
          b.addEventListener("click", function(){
            var i = state.conditions.indexOf(o.v);
            if(i > -1) state.conditions.splice(i, 1);
            else state.conditions.push(o.v);
            b.setAttribute("aria-pressed", state.conditions.indexOf(o.v) > -1 ? "true" : "false");
            cnt.textContent = state.conditions.length ? state.conditions.length + " selected" : "None selected";
          });
          grid.appendChild(b);
        });
        var next = el("button", "fyf-btn", "Continue");
        next.type = "button";
        next.addEventListener("click", function(){ state.step = 2; renderQuestion(); });
        var back = el("button", "fyf-btn ghost", "Back");
        back.type = "button";
        back.addEventListener("click", function(){ state.step = 0; renderQuestion(); });
        actions.appendChild(next); actions.appendChild(back); actions.appendChild(cnt);
        fs.appendChild(grid); fs.appendChild(actions);

      } else if(state.step === 2){
        fs.appendChild(legendFor(Q.speed, Q.speedHelp, false));
        SPEEDS.forEach(function(s){
          var b = tile(s[0], s[1], state.speed && state.speed[0] === s[0]);
          b.addEventListener("click", function(){
            state.speed = s;
            state.step = 3;
            if(DATA.showFormat) renderQuestion();
            else renderResults();
          });
          grid.appendChild(b);
        });
        var back2 = el("button", "fyf-btn ghost", "Back");
        back2.type = "button";
        back2.addEventListener("click", function(){ state.step = 1; renderQuestion(); });
        actions.appendChild(back2);
        fs.appendChild(grid); fs.appendChild(actions);

      } else {
        fs.appendChild(legendFor(Q.format, Q.formatHelp, true));
        var none = tile("No preference", "Show me the best option in any format", state.answeredFormat && state.format === null);
        none.className += " fyf-wide";
        none.addEventListener("click", function(){
          state.format = null; state.answeredFormat = true; state.step = RESULTS_STEP; renderResults();
        });
        grid.appendChild(none);
        formatOptions().forEach(function(o){
          var b = tile(o.type, (o.epoxy ? "Epoxy · " : "") + plural(o.n, "product"), state.format === o.type);
          b.addEventListener("click", function(){
            state.format = o.type; state.answeredFormat = true; state.step = RESULTS_STEP; renderResults();
          });
          grid.appendChild(b);
        });
        var skip = el("button", "fyf-btn", "Skip this step");
        skip.type = "button";
        skip.addEventListener("click", function(){
          state.format = null; state.answeredFormat = true; state.step = RESULTS_STEP; renderResults();
        });
        var back3 = el("button", "fyf-btn ghost", "Back");
        back3.type = "button";
        back3.addEventListener("click", function(){ state.step = 2; renderQuestion(); });
        actions.appendChild(skip); actions.appendChild(back3);
        fs.appendChild(grid); fs.appendChild(actions);
      }

      stage.appendChild(fs);
      if(state.step > 0){
        var f = stage.querySelector(".fyf-tile, .fyf-btn");
        if(f) f.focus({preventScroll:true});
      }
    }

    var TIER = {
      best:   {label:"Best",   flag:"Top match", blurb:"Matches the most of what you asked for."},
      better: {label:"Better", flag:null,        blurb:"Covers most of it, with a trade-off."},
      good:   {label:"Good",   flag:null,        blurb:"A simpler option that still holds."}
    };
    var LADDER = [["best"], ["best", "better"], ["best", "better", "good"]];
    var WAYS = {
      1: "One product fits this repair",
      2: "Two ways to make this repair",
      3: "Three ways to make this repair"
    };

    function refreshCartBubble(){
      fetch(ROUTES + "?sections=cart-icon-bubble").then(function(r){
        return r.json();
      }).then(function(s){
        var target = document.getElementById("cart-icon-bubble");
        if(!target || !s["cart-icon-bubble"]) return;
        var box = document.createElement("div");
        box.innerHTML = s["cart-icon-bubble"];
        var inner = box.querySelector("#cart-icon-bubble");
        if(inner) target.innerHTML = inner.innerHTML;
      }).catch(function(){});
    }

    function addToCart(vid, btn, original){
      btn.disabled = true;
      btn.textContent = "Adding...";
      fetch(ROUTES + "cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json", "Accept": "application/json"},
        body: JSON.stringify({items: [{id: vid, quantity: 1}]})
      }).then(function(r){
        if(!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function(){
        btn.textContent = "Added to cart";
        refreshCartBubble();
      }).catch(function(){
        btn.textContent = "Could not add, open the product";
      }).then(function(){
        btn.disabled = false;
        setTimeout(function(){
          if(btn.textContent === "Added to cart") btn.textContent = original;
        }, 4000);
      });
    }

    function startOverBtn(){
      var again = el("button", "fyf-btn ghost", "Start over");
      again.type = "button";
      again.addEventListener("click", function(){ state = newState(); renderQuestion(); });
      return again;
    }

    function renderResults(){
      stage.innerHTML = "";
      paintStepper();

      var cp = pools();
      var relaxed = cp.relaxed;
      var surfacePool = cp.surfacePool, strict = cp.strict;

      if(state.format){
        var fs2 = strict.filter(function(p){ return p.type === state.format; });
        var fp2 = surfacePool.filter(function(p){ return p.type === state.format; });
        if(fs2.length || fp2.length){ strict = fs2; surfacePool = fp2; }
        else relaxed = relaxed || "format";
      }

      function rank(list){
        return list.map(function(p){
          var r = score(p);
          return {p:p, s:r.score, hits:r.hits};
        }).sort(function(a, b){ return b.s - a.s; });
      }
      var primary = rank(strict);
      var secondary = rank(surfacePool.filter(function(p){ return strict.indexOf(p) < 0; }));
      var ordered = primary.concat(secondary);
      var matchSet = primary.length ? primary : secondary;
      var matchCount = matchSet.length;

      if(!ordered.length){
        var empty = el("div", "fyf-empty", "Nothing matched those answers. ");
        var a0 = el("a", null, "Browse " + DATA.collectionTitle);
        a0.href = DATA.collectionUrl;
        empty.appendChild(a0);
        stage.appendChild(empty);
        var row = el("div", "fyf-actions");
        row.appendChild(startOverBtn());
        stage.appendChild(row);
        return;
      }

      if(relaxed){
        var msg = el("div", "fyf-relaxed");
        var strong = el("b", null, relaxed === "format" ? "Format dropped." : "No exact match.");
        msg.appendChild(strong);
        msg.appendChild(document.createTextNode(
          relaxed === "conditions"
            ? " Nothing covers " + lower(state.surface) + " with all of those conditions at once, so these are the closest. Matched conditions are highlighted."
            : relaxed === "format"
            ? " Nothing in that format fits the rest of your answers, so these are ranked without it."
            : " Nothing lists that surface, so these are ranked on your other answers."
        ));
        stage.appendChild(msg);
      }

      var picks = [], usedTypes = {};
      if(!state.format){
        ordered.forEach(function(r){
          if(picks.length >= 3 || usedTypes[r.p.type]) return;
          picks.push(r);
          usedTypes[r.p.type] = 1;
        });
      }
      ordered.forEach(function(r){
        if(picks.length >= 3 || picks.indexOf(r) > -1) return;
        picks.push(r);
      });
      picks.sort(function(a, b){ return b.s - a.s; });
      var names = LADDER[Math.max(picks.length - 1, 0)] || [];

      var hdr = el("div", "fyf-reshead");
      hdr.appendChild(el("div", "fyf-eyebrow", "Your fix"));
      hdr.appendChild(el("p", "fyf-ressub", WAYS[picks.length] || "Your match"));
      var anyEpoxy = picks.some(function(r){ return isEpoxy(r.p); });
      if(anyEpoxy){
        hdr.appendChild(el("p", "fyf-resnote", "Epoxy systems are ranked first where they already match the surface and conditions you chose."));
      }
      stage.appendChild(hdr);

      function whyLine(r, tierKey){
        var bits = [];
        if(r.hits.length) bits.push(r.hits.map(lower).join(" and "));
        if(r.p.set) bits.push("sets in " + lower(r.p.set));
        var missed = state.conditions.filter(function(c){ return r.hits.indexOf(c) < 0; });
        var lead = bits.length ? "Rated for " + bits.join(", ") + "." : "";
        var tail = missed.length ? " Not rated for " + missed.map(lower).join(" or ") + "." : "";
        var out = (lead + tail).replace(/^ +| +$/g, "");
        return out || TIER[tierKey].blurb;
      }

      var tiers = el("div", "fyf-tiers");
      picks.forEach(function(r, i){
        var key = names[i], t = TIER[key];
        var c = el("div", "fyf-tier fyf-tier--" + key);

        var head = el("div", "fyf-tierhead");
        var lead = el("div", "fyf-tierlead");
        lead.appendChild(el("span", "fyf-rank", t.label));
        if(isEpoxy(r.p)) lead.appendChild(el("span", "fyf-epoxy", "Epoxy"));
        head.appendChild(lead);
        if(t.flag) head.appendChild(el("span", "fyf-flag", t.flag));
        c.appendChild(head);

        if(r.p.img){
          var im = document.createElement("img");
          im.className = "fyf-thumb";
          im.src = r.p.img;
          im.alt = r.p.alt || r.p.t;
          im.loading = "lazy";
          im.width = 320;
          im.height = 320;
          c.appendChild(im);
        }

        var h3 = el("h3");
        var link = el("a", null, r.p.t);
        link.href = r.p.url;
        h3.appendChild(link);
        c.appendChild(h3);

        if(r.p.price) c.appendChild(el("div", "fyf-price", r.p.price));
        c.appendChild(el("p", "fyf-why", whyLine(r, key)));

        var dl = el("dl", "fyf-spec");
        function spec(k, v){
          if(!v) return;
          dl.appendChild(el("dt", null, k));
          dl.appendChild(el("dd", null, v));
        }
        spec("Type", r.p.type);
        spec("Set time", r.p.set || "Not published");
        spec("Cure color", r.p.col || "Not published");
        c.appendChild(dl);

        if(r.p.att.length){
          var chips = el("div", "fyf-chips");
          r.p.att.slice(0, 4).forEach(function(a){
            chips.appendChild(el("span", "fyf-chip" + (r.hits.indexOf(a) > -1 ? " hit" : ""), a));
          });
          c.appendChild(chips);
        }

        var foot = el("div", "fyf-foot");
        if(r.p.avail && r.p.vid){
          var label = "Add to cart";
          var add = el("button", "fyf-cta", label);
          add.type = "button";
          add.addEventListener("click", function(){ addToCart(r.p.vid, add, label); });
          foot.appendChild(add);
        } else {
          var so = el("button", "fyf-cta", "Sold out");
          so.type = "button";
          so.disabled = true;
          foot.appendChild(so);
        }
        var alt = el("a", "fyf-alt", "View product details");
        alt.href = r.p.url;
        foot.appendChild(alt);
        c.appendChild(foot);

        tiers.appendChild(c);
      });
      stage.appendChild(tiers);

      var panel = el("div", "fyf-matrix");
      panel.hidden = true;
      panel.id = "fyf-all-" + (DATA.sectionId || "0");
      var phead = el("div", "fyf-mhead");
      phead.appendChild(el("b", null, "All " + matchCount + " products"));
      phead.appendChild(document.createTextNode(
        " matching " + lower(state.surface) +
        (state.conditions.length ? " · " + state.conditions.join(" · ") : "") +
        (state.format ? " · " + state.format : "") + "."
      ));
      panel.appendChild(phead);

      matchSet.forEach(function(r){
        var row = el("div", "fyf-mrow");
        var nm = el("div", "fyf-mname");
        var na = el("a", null, r.p.t);
        na.href = r.p.url;
        nm.appendChild(na);
        if(isEpoxy(r.p)) nm.appendChild(el("span", "fyf-chip", "Epoxy"));
        row.appendChild(nm);
        row.appendChild(el("div", "fyf-mmeta",
          (r.p.type || "Product") + (r.p.set ? " · sets in " + lower(r.p.set) : " · set time not published")));
        var a = el("a", "fyf-mlink", r.p.price ? r.p.price : "View product");
        a.href = r.p.url;
        row.appendChild(a);
        panel.appendChild(row);
      });

      var acts = el("div", "fyf-actions");
      var openLabel = "See all " + matchCount + " matching products";
      var all = el("button", "fyf-btn", openLabel);
      all.type = "button";
      all.setAttribute("aria-expanded", "false");
      all.setAttribute("aria-controls", panel.id);
      all.addEventListener("click", function(){
        var show = panel.hidden;
        panel.hidden = !show;
        all.setAttribute("aria-expanded", show ? "true" : "false");
        all.textContent = show ? "Hide full list" : openLabel;
        if(show) panel.scrollIntoView({behavior:"smooth", block:"nearest"});
      });
      acts.appendChild(all);
      acts.appendChild(startOverBtn());
      stage.appendChild(acts);
      stage.appendChild(panel);
    }

    if(!P.length){
      stage.innerHTML = "";
      stage.appendChild(el("div", "fyf-empty",
        "No products in this collection have use_on or attributes metafields filled in yet, so the finder has nothing to match against."));
      return;
    }

    renderQuestion();
  }

  function initAll(){
    var nodes = document.querySelectorAll("[data-fyf-section]");
    for(var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function(e){
    var n = e.target.querySelector ? e.target.querySelector("[data-fyf-section]") : null;
    if(n) boot(n);
  });
})();
